@if (visible()) {
  <div class="nv-shift-footer">
    <span class="nv-shift-footer__shift">
      <span class="nv-shift-footer__dot" aria-hidden="true"></span>
      <b>{{ shiftLabel() }} shift</b>
    </span>
    <span class="nv-shift-footer__stat">Sales <b>{{ salesLabel() }}</b></span>
    <span class="nv-shift-footer__stat nv-shift-footer__stat--wide">Guests served <b>{{ guestsServed() }}</b></span>
    <span class="nv-shift-footer__spacer"></span>
    <span class="nv-shift-footer__stat">Cash in drawer <b class="nv-shift-footer__big">{{ cashInDrawerLabel() }}</b></span>
    <span class="nv-shift-footer__divider" aria-hidden="true"></span>
    <span class="nv-shift-footer__stat">Free tables <b class="nv-shift-footer__big">{{ freeCount() }} / {{ totalTables() }}</b></span>
    @if (canSeeDaySummary()) {
      <span class="nv-shift-footer__divider nv-shift-footer__divider--link" aria-hidden="true"></span>
      <a class="nv-shift-footer__link" routerLink="/insights" [queryParams]="{ view: 'summary', period: 'day' }">
        Day summary
        <nv-icon [size]="18">arrow_forward</nv-icon>
      </a>
    }
  </div>
}
